import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  email = new FormControl('', [Validators.required, Validators.email]);
  new_password = new FormControl('', [Validators.required, Validators.minLength(6)]);
  confirm_password = new FormControl('', [Validators.required, Validators.minLength(6)]);
  hide: boolean = true;
  error_message: string;
  code: string = null;
  mode: string = null;
  constructor(private auth: AuthService,
    private router: Router,
    private activatedActivated: ActivatedRoute,
    private snackBar: MatSnackBar) {

  }

  ngOnInit() {
    this.code = this.activatedActivated.snapshot.queryParams['oobCode'];
    this.mode = this.activatedActivated.snapshot.queryParams['mode'];
    console.log(this.code)
    console.log(this.mode)
  }

  sendOTP() {
    this.error_message = null;
    if (this.email.status == 'VALID') {
      this.auth.sendPasswordResetEmail(this.email.value).then(data => {
        this.presentSnackBar("Reset password request sent to mail")
      }, error => {
        this.presentSnackBar(error.message)
      })
    }
  }

  changePassword() {
    this.error_message = null
    if (this.new_password.status == 'VALID' && this.confirm_password.status == 'VALID') {
      if (this.new_password.value != this.confirm_password.value) {
        this.error_message = "Confirm Password is wrong"
      } else {
        this.auth.confirmPasswordReset(this.code, this.new_password.value).then(data => {
          this.presentSnackBar("Password Updated")
          this.router.navigate(['/sign-in'])
        }).catch(error => {
          console.log(error)
        })
      }
    }
    console.log(this.error_message)
  }

  presentSnackBar(message) {
    this.snackBar.open(message, null,
      {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
      })
  }

}
